import { render, staticRenderFns } from "./Recaps.vue?vue&type=template&id=3023b261&"
import script from "./Recaps.vue?vue&type=script&lang=js&"
export * from "./Recaps.vue?vue&type=script&lang=js&"
import style0 from "./Recaps.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports